import { Client, ClientPoc } from '../types';

export const normalizePocEmail = (email: string): string => email.trim().toLowerCase();

export const clientPocsWithEmail = (client: Client | null | undefined): ClientPoc[] => {
  const pocs = client?.pocs ?? [];
  const seen = new Set<string>();
  const result: ClientPoc[] = [];
  for (const poc of pocs) {
    const email = poc.email?.trim();
    if (!email) continue;
    const key = normalizePocEmail(email);
    if (seen.has(key)) continue;
    seen.add(key);
    result.push({ ...poc, email });
  }
  return result;
};

export const formatClientPocLabel = (poc: Pick<ClientPoc, 'full_name' | 'email'>): string => {
  const name = poc.full_name?.trim() || '';
  const email = poc.email?.trim() || '';
  if (name && email) return `${name} · ${email}`;
  return name || email;
};

export const pocSelectionEmail = (option: ClientPoc | string): string =>
  (typeof option === 'string' ? option : option.email || '').trim();

export const filterClientPocOptions = <T extends ClientPoc | string>(
  options: T[],
  inputValue: string,
): T[] => {
  const query = inputValue.trim().toLowerCase();
  if (!query) return options;
  return options.filter((option) => {
    if (typeof option === 'string') return option.toLowerCase().includes(query);
    return (
      (option.full_name || '').toLowerCase().includes(query) ||
      (option.email || '').toLowerCase().includes(query) ||
      (option.job_position || '').toLowerCase().includes(query)
    );
  });
};
